export const extractErrorMessage = (error, fallbackMessage, t) => {
  console.log(error);
  // Handle legacy format
  if (error.response?.data?.error && error.response.data.error.code) {
    return t(error.response.data.error.code) || error.response.data.error.message;
  }
  // Handle simple detail string
  if (error.response?.data?.detail && typeof error.response.data.detail === 'string') {
    return error.response.data.detail;
  }
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return fallbackMessage;
};
